import { Injectable } from '@angular/core';
import hmacSHA1 from 'crypto-js/hmac-sha1';
import Base64 from 'crypto-js/enc-base64';

import { environment } from '../../environments/environment';

// :: @@ FOUD THIS ON THE WEB AND KICK STARTED ME FROM THERE
// https://stackoverflow.com/questions/52177791/angular-6-woocommerce-rest-authentication

// const WooCommerceConfig = {
//   url: 'https://temperosystems.com.au',
//   consumerKey: 'ck_ce1b81259bfb4307aee5fd726bb32be9e1c779aa',
//   consumerSecret: 'cs_6a5e5d1cdd2b4b0f1c41ef2dc718778e776b9420',
//   wpAPI: true,
//   version: 'wc/v2',
//   queryStringAuth: true // Force Basic Authentication as query string true and using under HTTPS
// };


// local locahost::DEV Envirnoment 2023
// export const environment = {
//   // origin: '', // angular pps was adding to all API calls as well and breaking all the api systms
//   origin: 'https://dev.temperosystems.com.au',
//   wcEndpoint: '/wp-json/wc/v3',
//   woocommerce: {
//     consumer_key: 'ck_fcb7d27320f59f314226e565fc610e5f61381ee5',
//     consumer_secret: 'cs_6230f8265cbc63d03f02f8ea6a5dd147ccf06f2a',
//   },
// };


// export const environment = {
//     // origin: '', // angular pps was adding to all API calls as well and breaking all the api systms
//     origin: 'https://localhost/dev.temperosystems.com.au',
//     wcEndpoint: '/wp-json/wc/v3',
//     woocommerce: {
//       consumer_key: 'ck_9b509b9848a9f9c39fe5f96803fa3e165be1fa0e',
//       consumer_secret: 'cs_504bd1d2814faaeb0b67dae7b826c5dcc5318f2f',
//     },
//   };


@Injectable({
  providedIn: 'root'
})
export class WordpressService {

  nonce: string = ''
  currentTimestamp: number = 0 
  customer_key: string = environment.brand_api_key;
  customer_secret: string = environment.brand_api_secret;
  constructor() { }

  authenticateApi(method,url,params) {
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    this.nonce ='';
    for(var i = 0; i < 6; i++) {
        this.nonce += possible.charAt(Math.floor(Math.random() * possible.length));
    }    
    this.currentTimestamp = Math.floor(new Date().getTime() / 1000);

    let authParam:object ={
        oauth_consumer_key : this.customer_key,
        oauth_nonce : this.nonce,
        oauth_signature_method : 'HMAC-SHA1',
        oauth_timestamp : this.currentTimestamp,
        oauth_version : '1.0',
    } 



    let parameters = Object.assign({}, authParam, params);
    let signatureStr:string = '';
    Object.keys(parameters).sort().forEach(function(key) {
        if(signatureStr == '')
            signatureStr += key+'='+parameters[key];
        else
            signatureStr += '&'+key+'='+parameters[key];
    });
    let paramStr:string = '';
    Object.keys(params).sort().forEach(function(key) {

        paramStr += '&'+key+'='+parameters[key];
    });
    // return url+'?oauth_consumer_key='+this.customer_key+'&oauth_nonce='+this.nonce+'&oauth_signature_method=HMAC-SHA1&oauth_timestamp='+this.currentTimestamp+'&oauth_version=1.0&oauth_signature='+Base64.stringify(hmacSHA1(method+'&'+encodeURIComponent(url)+'&'+encodeURIComponent(signatureStr),this.customer_secret+'&'))+paramStr;
    return url+'?oauth_consumer_key='+this.customer_key+'&oauth_nonce='+this.nonce+'&oauth_signature_method=HMAC-SHA1&oauth_timestamp='+this.currentTimestamp+'&oauth_version=1.0&oauth_signature='+Base64.stringify(hmacSHA1(method+'&'+encodeURIComponent(url)+'&'+encodeURIComponent(signatureStr),this.customer_secret+'&'))+paramStr;

/// // 


  }


  authenticateApi_NoParams(method,url) {
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    this.nonce ='';
    for(var i = 0; i < 6; i++) {
        this.nonce += possible.charAt(Math.floor(Math.random() * possible.length));
    }    
    this.currentTimestamp = Math.floor(new Date().getTime() / 1000);

    let authParam:object ={
        oauth_consumer_key : this.customer_key,
        oauth_nonce : this.nonce,
        oauth_signature_method : 'HMAC-SHA1',
        oauth_timestamp : this.currentTimestamp,
        oauth_version : '1.0',
    } 
    let parameters = Object.assign({}, authParam);
    let signatureStr:string = '';
    Object.keys(parameters).sort().forEach(function(key) {
        if(signatureStr == '')
            signatureStr += key+'='+parameters[key];
        else
            signatureStr += '&'+key+'='+parameters[key];
    });
    // let paramStr:string = '';
    // Object.keys(params).sort().forEach(function(key) {

    //     paramStr += '&'+key+'='+parameters[key];
    // });
    // return '?oauth_consumer_key='+this.customer_key+'&oauth_nonce='+this.nonce+'&oauth_signature_method=HMAC-SHA1&oauth_timestamp='+this.currentTimestamp+'&oauth_version=1.0&oauth_signature='+Base64.stringify(hmacSHA1(method+'&'+encodeURIComponent(url)+'&'+encodeURIComponent(signatureStr),this.customer_secret+'&'));
    return url+'?oauth_consumer_key='+this.customer_key+'&oauth_nonce='+this.nonce+'&oauth_signature_method=HMAC-SHA1&oauth_timestamp='+this.currentTimestamp+'&oauth_version=1.0&oauth_signature='+Base64.stringify(hmacSHA1(method+'&'+encodeURIComponent(url)+'&'+encodeURIComponent(signatureStr),this.customer_secret+'&'));
    // return url+'?oauth_consumer_key='+this.customer_key+'&oauth_nonce='+this.nonce+'&oauth_signature_method=HMAC-SHA1&oauth_timestamp='+this.currentTimestamp+'&oauth_version=1.0&oauth_signature='+Base64.stringify(hmacSHA1(method+'&'+encodeURIComponent(url)+'&'+encodeURIComponent(signatureStr),this.customer_secret+'&'));

  }





/// does nothing yet.
  authenticateApi_Webhooks(method,url,params) {
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    this.nonce ='';
    for(var i = 0; i < 6; i++) {
        this.nonce += possible.charAt(Math.floor(Math.random() * possible.length));
    }    
    this.currentTimestamp = Math.floor(new Date().getTime() / 1000);

    let authParam:object ={
        oauth_consumer_key : this.customer_key,
        oauth_nonce : this.nonce,
        oauth_signature_method : 'HMAC-SHA1',
        oauth_timestamp : this.currentTimestamp,
        oauth_version : '1.0',
    } 


    // let authParam:object ={
    //     oauth_consumer_key : this.customer_key,
    //     oauth_nonce : this.nonce,
    //     oauth_signature_method : 'HMAC-SHA1',
    //     oauth_timestamp : this.currentTimestamp,
    //     oauth_version : '1.0',


    // } 

    // The wordpress Hook System Uses A specifc set of headers and passes the hook directly.
/*
X-WC-Webhook-Source: http://example.com/.
X-WC-Webhook-Topic - e.g. order.updated.
X-WC-Webhook-Resource - e.g. order.
X-WC-Webhook-Event - e.g. updated.
X-WC-Webhook-Signature - a base64 encoded HMAC-SHA256 hash of the payload.
X-WC-Webhook-ID - webhook's post ID.
X-WC-Delivery-ID - delivery log ID (a comment).
*/


    let parameters = Object.assign({}, authParam, params);
    let signatureStr:string = '';
    Object.keys(parameters).sort().forEach(function(key) {
        if(signatureStr == '')
            signatureStr += key+'='+parameters[key];
        else
            signatureStr += '&'+key+'='+parameters[key];
    });
    let paramStr:string = '';
    Object.keys(params).sort().forEach(function(key) {

        paramStr += '&'+key+'='+parameters[key];
    });
    // return url+'?oauth_consumer_key='+this.customer_key+'&oauth_nonce='+this.nonce+'&oauth_signature_method=HMAC-SHA1&oauth_timestamp='+this.currentTimestamp+'&oauth_version=1.0&oauth_signature='+Base64.stringify(hmacSHA1(method+'&'+encodeURIComponent(url)+'&'+encodeURIComponent(signatureStr),this.customer_secret+'&'))+paramStr;
    return url+'?oauth_consumer_key='+this.customer_key+'&oauth_nonce='+this.nonce+'&oauth_signature_method=HMAC-SHA1&oauth_timestamp='+this.currentTimestamp+'&oauth_version=1.0&oauth_signature='+Base64.stringify(hmacSHA1(method+'&'+encodeURIComponent(url)+'&'+encodeURIComponent(signatureStr),this.customer_secret+'&'))+paramStr;

/// // 


  }










}